import { HTTPMethod } from '@perpay-web/constants/httpMethods';
import { useDataModule } from '@perpay-web/data-module/useDataModule';
import { useReduxDataModuleHookConnection } from '@perpay-web/data-module/useReduxDataModuleHookConnection';
import {
    submitCardApplication,
    submitCardApplicationError,
    submitCardApplicationReset,
    submitCardApplicationSuccess,
} from '@perpay-web/fintech/actions/entities/cardAccountApplications';
import { PARTNER_ONBOARDING_SUBMIT_CARD_APPLICATION_ENDPOINT } from '@perpay-web/fintech/constants/urls';
import { authenticatedJsonFetch } from '@perpay-web/fintech/utils/requestHandlers';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

const useSubmitCardApplicationDataModule = () => {
    const dataModule = useDataModule(
        (payload) =>
            authenticatedJsonFetch(
                PARTNER_ONBOARDING_SUBMIT_CARD_APPLICATION_ENDPOINT,
                payload,
                HTTPMethod.post,
            ),
        { timeout: 30000 },
    );

    useReduxDataModuleHookConnection({
        dataModule,
        hookAction$,
        request: submitCardApplication,
        error: submitCardApplicationError,
        success: submitCardApplicationSuccess,
        reset: submitCardApplicationReset,
    });

    return dataModule;
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const dataModule = useSubmitCardApplicationDataModule();

        return (
            <Context.Provider value={dataModule}>{children}</Context.Provider>
        );
    };

    return Provider;
};

export const [
    UseSubmitCardApplicationDataModuleProvider,
    useSubmitCardApplicationContext,
] = createContextProvider(providerFactory);
